module.exports = __webpack_public_path__ + "img/thumb_14.6678324f.jpg";